module.exports = __webpack_public_path__ + "img/70.b15a2994.png";